// UserPredictedScoreModal
import React, {useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import IconModalCross from "../../assets/images/eoro-2024/icon-modal-cross.svg";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";

import border from "../../assets/images/eoro-2024/thick-border.svg";
import PredictedJokerMatchCard from "./PredictedJokerMatchCard";
import PredictedScoreCard from "./PredictedScoreCard";

const UserPredictedScoreModal = (props) => {
    const {
        isMobile,
        showModal,
        setShowModal,
        userPredictedData,

    } = props;
    // console.log("userPredictedData in modal is >>>", userPredictedData)


    const render = () => {
        return (
            <>
                <Modal
                    show={showModal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    onHide={() => {
                        setShowModal(false)
                    }}
                    scrollable={true}
                >
                    <Modal.Header className={"p-0 m-0 px-3 py-2 d-flex flex-column border-0"}>
                        <div className={"d-flex justify-content-between align-items-center w-100 py-2"}>
                            {
                                userPredictedData?.joker_game ?
                                    <>
                                        <Modal.Title className={"fw-700 cabin font-25"}>Joker Game</Modal.Title>
                                    </>
                                    :
                                    <>
                                        <div></div>
                                    </>
                            }
                            <div className={"w-auto"} role={"button"} onClick={() => {
                                setShowModal(false)
                            }}>
                                <img
                                    src={IconModalCross}
                                    alt={"icon"}
                                    // className={"img-fluid"}
                                    height={25}
                                />
                            </div>
                        </div>
                        <div className={`${isMobile ? "w-100" : "w-75"}`}>
                            {
                                userPredictedData?.joker_game &&
                                <>
                                    <PredictedJokerMatchCard
                                        isMobile={isMobile}
                                        match={userPredictedData?.joker_game}
                                    />
                                </>
                            }
                            {/*<>*/}
                            {/*    <div className={"pt-5 pb-4 text-skins-red text-center fw-800 font-40 bebas"}>*/}
                            {/*        No Joker Game*/}
                            {/*    </div>*/}
                            {/*</>*/}
                        </div>
                        {
                            userPredictedData?.joker_game &&
                            <>
                                <div className={"w-75 d-flex align-items-center justify-content-center mt-3"}>
                                    <div className={"w-100"}>
                                        <img
                                            src={border}
                                            alt={"img"}
                                            className={"w-100 h-100"}
                                        />
                                    </div>
                                </div>
                            </>
                        }

                    </Modal.Header>
                    <Modal.Body className={"py-0"}>
                        <div className={"fw-700 cabin font-25 mb-2"}>Score Predicted</div>
                        <Row className={""}>
                            {
                                userPredictedData?.matches?.map((match, index) => (
                                    <Col
                                        md={6}
                                        key={index}
                                        className={""}
                                    >
                                        <PredictedScoreCard
                                            key={index}
                                            isMobile={isMobile}
                                            match={match}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

    return render();
}

export default UserPredictedScoreModal;
